module.exports = __webpack_public_path__ + "media/images/ir/common/Acrobat-Reader-b5a470693fe27476c3750e08b521c78a.png";